import { requester } from '../utils';

export const getMyUnreadNotification = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/panel-notification/unread/me`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch notificatuon error', err);
        reject(err);
      });
  });
};

export const putMyReadNotification = cafeIds => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/panel-notification/mark-as-read`,
        method: 'PUT',
        data: cafeIds
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
